<template>
  <div class="v-status-toggler" @click="toggle">
    <slot :flag="flag"></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag: this.trueOnInit
    }
  },
  methods: {
    toggle () {
      if (this.flag) {
        this.setFalse.bind(this)()
      } else {
        this.setTrue.bind(this)()
      }
    }
  },
  props: {
    trueOnInit: {
      default: true,
      type: Boolean
    },
    setTrue: {
      default() { this.flag = true },
      type: Function
    },
    setFalse: {
      default() { this.flag = false },
      type: Function
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VStatusToggler.vue